import React from 'react'
import Profile from './Profile'
import OrderHistory from './OrderHistory'
import TermsandCondition from './TermsandCondition'
import { useSelector } from 'react-redux'
import { authenticateSelector } from '../api/userAuth'

const IndexUser = () => {
 
  const {user}= useSelector(authenticateSelector)
  return (
<>
  <div
    className="md:flex-row md:space-x-4 w-full mx-auto lg:mt-36"
    style={{ fontFamily: 'Lato, sans-serif' }}
  >
    <div className="w-full md:w-5/6 mb-4 md:mb-0 mx-auto">
      <Profile />
    </div>
    <div className="w-full mx-auto">
      {console.log("hai hai hoi", user?._id)}
      <OrderHistory userid={user?._id} />
    </div>
  </div>

  {/* Button visible only on mobile */}
  <div className="block md:hidden mt-16 px-4">
    <button
      className="w-full bg-gray-300 text-gray-600 font-semibold py-2 px-4 rounded cursor-not-allowed"
      disabled
    >
      Careers
    </button>
  </div>
</>





  )
}

export default IndexUser
